import { SectionMessage as CascdiaSectionMessage } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import Markdown from "react-markdown";

export function SectionMessage(props: ControlProps) {
  const {
    uischema: { options },
  } = props;

  return (
    <CascdiaSectionMessage
      icon={options?.icon}
      type={options?.type}
      sectionTitle={options?.title}
    >
      <Markdown
        components={{
          p: "span",
          ul(props) {
            const { node, ref, ...rest } = props;
            return <ul className={styles.messagesList} {...rest} />;
          },
        }}
      >
        {options?.body}
      </Markdown>
    </CascdiaSectionMessage>
  );
}

const styles = {
  messagesList: css({
    paddingInlineStart: 21,
  }),
};

export const SectionMessageRenderer = withJsonFormsControlProps(SectionMessage);
